// Author YuJiaBei
// Date 2021-11-15 10:12:29

class EmSicMonitorPointSmp {
constructor({
        id = null,
        smpCode = '',
        smpType = '',
        smpName = '',
        smpCodeBda = '',
        smpLocation = '',
        smpUnit = '',
        smpMRangeUpperLimit = '',
        smpMRangeLowerLimit = '',
        smpAlarmUpperLimit = '',
        smpAlarmLowerLimit = '',
        smpRelation = '',
        smpIDEoc = '',
        eocName = '',
        eocNodeId = '',
        eocNodeCode = '',
        remark = ''}
= {}) {
    this.id = id;
    this.smpCode = smpCode;
    this.smpType = smpType;
    this.smpName = smpName;
    this.smpCodeBda = smpCodeBda;
    this.smpLocation = smpLocation;
    this.smpUnit = smpUnit;
    this.smpMRangeUpperLimit = smpMRangeUpperLimit;
    this.smpMRangeLowerLimit = smpMRangeLowerLimit;
    this.smpAlarmUpperLimit = smpAlarmUpperLimit;
    this.smpAlarmLowerLimit = smpAlarmLowerLimit;
    this.smpRelation = smpRelation;
    this.smpIDEoc = smpIDEoc;
    this.eocName = eocName;
    this.eocNodeId = eocNodeId;
    this.eocNodeCode = eocNodeCode;
    this.remark = remark;
}
}

function newEntity() {
return new EmSicMonitorPointSmp();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'smpCode',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.grid.smpCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'smpType',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.grid.smpType',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: 'DT', text: '多太量' },
                            { value: 'MN', text: '模拟量' },
                            { value: 'BH', text: '保护量' },
                            { value: 'KG', text: '开关量' },
                            { value: 'LJ', text: '累积量' },
                            { value: 'KZ', text: '控制量' }
            ]
        }
        },
        {
        key: 'smpName',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.grid.smpName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'smpCodeBda',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.grid.smpCodeBda',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'smpLocation',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.grid.smpLocation',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'smpUnit',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.grid.smpUnit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'smpMRangeUpperLimit',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.grid.smpMRangeUpperLimit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'smpMRangeLowerLimit',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.grid.smpMRangeLowerLimit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'smpAlarmUpperLimit',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.grid.smpAlarmUpperLimit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'smpAlarmLowerLimit',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.grid.smpAlarmLowerLimit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'smpRelation',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.grid.smpRelation',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'smpIDEoc',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.grid.smpIDEoc',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eocName',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.grid.eocName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eocNodeId',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.grid.eocNodeId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eocStatusNodeId',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.grid.eocStatusNodeId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eocStatusWarnGte',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.grid.eocStatusWarnGte',
        sortable: true,
        form: {
        type: 'inputNumber'
        }
        },
        {
        key: 'eocStatusWarnLt',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.grid.eocStatusWarnLt',
        sortable: true,
        form: {
        type: 'inputNumber'
        }
        },
        {
        key: 'eocStatusErrorGte',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.grid.eocStatusErrorGte',
        sortable: true,
        form: {
        type: 'inputNumber'
        }
        },
        {
        key: 'eocStatusErrorLt',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.grid.eocStatusErrorLt',
        sortable: true,
        form: {
        type: 'inputNumber'
        }
        },
        {
        key: 'eocNodeCode',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.grid.eocNodeCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eoctName',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.grid.eoctName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    smpCodeFilter : '',
    smpTypeFilter : '',
    smpNameFilter : '',
    smpCodeBdaFilter : '',
    smpLocationFilter : '',
    smpUnitFilter : '',
    smpMRangeUpperLimitFilter : '',
    smpMRangeLowerLimitFilter : '',
    smpAlarmUpperLimitFilter : '',
    smpAlarmLowerLimitFilter : '',
    smpRelationFilter : '',
    smpIDEocFilter : '',
    eocNameFilter : '',
    eocNodeIdFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'smpCodeFilter',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.filter.smpCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'smpTypeFilter',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.filter.smpType',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'smpNameFilter',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.filter.smpName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'smpCodeBdaFilter',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.filter.smpCodeBda',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'smpLocationFilter',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.filter.smpLocation',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'smpUnitFilter',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.filter.smpUnit',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'smpMRangeUpperLimitFilter',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.filter.smpMRangeUpperLimit',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'smpMRangeLowerLimitFilter',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.filter.smpMRangeLowerLimit',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'smpAlarmUpperLimitFilter',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.filter.smpAlarmUpperLimit',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'smpAlarmLowerLimitFilter',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.filter.smpAlarmLowerLimit',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'smpRelationFilter',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.filter.smpRelation',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'smpIDEocFilter',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.filter.smpIDEoc',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emOpcComputedEoc'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'eocNameFilter',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.filter.eocName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eocNodeIdFilter',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.filter.eocNodeId',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'smpCode',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.entity.smpCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'smpType',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.entity.smpType',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
            ,required: true
            ,showLabelSelectOne: true
        ,options: [
                { value: 'DT', text: '多太量' },
                { value: 'MN', text: '模拟量' },
                { value: 'BH', text: '保护量' },
                { value: 'KG', text: '开关量' },
                { value: 'LJ', text: '累积量' },
                { value: 'KZ', text: '控制量' }
            ]
        }
        },
        {
        key: 'smpName',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.entity.smpName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'smpCodeBda',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.entity.smpCodeBda',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'imfSicEquipmentInfoIsei'
            ,correspondingField: 'iseiCode'
                }
        },
        {
        key: 'smpLocation',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.entity.smpLocation',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'smpUnit',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.entity.smpUnit',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'smpMRangeUpperLimit',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.entity.smpMRangeUpperLimit',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'smpMRangeLowerLimit',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.entity.smpMRangeLowerLimit',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'smpAlarmUpperLimit',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.entity.smpAlarmUpperLimit',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'smpAlarmLowerLimit',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.entity.smpAlarmLowerLimit',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'smpRelation',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.entity.smpRelation',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'smpIDEoc',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.entity.smpIDEoc',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emOpcComputedEoc'
            ,correspondingField: 'id'
            ,fieldsBindingByEntityModalSelected: '{"eocNodeCode":"nodeCode","eocName":"name","eocNodeId":"eocNodeId"}'
                }
        },
        {
        key: 'eocName',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.entity.eocName',
        sortable: true,
        disabled: true,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eocNodeId',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.entity.eocNodeId',
        sortable: true,
        disabled: true,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eocNodeCode',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.entity.eocNodeCode',
        sortable: true,
        disabled: true,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.em.statusCollection.emSicMonitorPointSmp.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmSicMonitorPointSmp, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
